module.exports = "<div class=item-lookup> Gelet op <a href=# v-if=art @click.prevent=\"show=!show\" v-text=art.title></a> <span v-if=\"!art || editing\"> <input type=text v-model=value keydown.enter=\"editing=false\"> </span> <span class=item-toggle v-else @click=\"editing=!editing\">bewerken</span> <p v-if=show&&art v-text=art.text class=item-lookup-text></p> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemLookup.vue
 ** module id = 139
 ** module chunks = 0
 **/